export default [
  { "Country": "AF", "Country Name": "Afghanistan" },
  { "Country": "AX", "Country Name": "Aland Islands" },
  { "Country": "AL", "Country Name": "Albania" },
  { "Country": "DZ", "Country Name": "Algeria" },
  { "Country": "AS", "Country Name": "American Samoa" },
  { "Country": "AD", "Country Name": "Andorra" },
  { "Country": "AO", "Country Name": "Angola" },
  { "Country": "AI", "Country Name": "Anguilla" },
  { "Country": "AQ", "Country Name": "Antarctica" },
  { "Country": "AG", "Country Name": "Antigua And Barbuda" },
  { "Country": "AR", "Country Name": "Argentina" },
  { "Country": "AM", "Country Name": "Armenia" },
  { "Country": "AW", "Country Name": "Aruba" },
  { "Country": "AU", "Country Name": "Australia" },
  { "Country": "CW", "Country Name": "Curaçao" },
  { "Country": "AT", "Country Name": "Austria" },
  { "Country": "AZ", "Country Name": "Azerbaijan" },
  { "Country": "BS", "Country Name": "Bahamas" },
  { "Country": "BH", "Country Name": "Bahrain" },
  { "Country": "BD", "Country Name": "Bangladesh" },
  { "Country": "BB", "Country Name": "Barbados" },
  { "Country": "BY", "Country Name": "Belarus" },
  { "Country": "BE", "Country Name": "Belgium" },
  { "Country": "BZ", "Country Name": "Belize" },
  { "Country": "BJ", "Country Name": "Benin" },
  { "Country": "BM", "Country Name": "Bermuda" },
  { "Country": "BT", "Country Name": "Bhutan" },
  { "Country": "BO", "Country Name": "Bolivia" },
  { "Country": "BA", "Country Name": "Bosnia And Herzegovina" },
  { "Country": "BW", "Country Name": "Botswana" },
  { "Country": "BV", "Country Name": "Bouvet Island" },
  { "Country": "BR", "Country Name": "Brazil" },
  { "Country": "IO", "Country Name": "British Indian Ocean Territory" },
  { "Country": "BN", "Country Name": "Brunei Darussalam" },
  { "Country": "BG", "Country Name": "Bulgaria" },
  { "Country": "BF", "Country Name": "Burkina Faso" },
  { "Country": "BI", "Country Name": "Burundi" },
  { "Country": "KH", "Country Name": "Cambodia" },
  { "Country": "CM", "Country Name": "Cameroon" },
  { "Country": "CA", "Country Name": "Canada" },
  { "Country": "CV", "Country Name": "Cape Verde" },
  { "Country": "KY", "Country Name": "Cayman Islands" },
  { "Country": "CF", "Country Name": "Central African Republic" },
  { "Country": "TD", "Country Name": "Chad" },
  { "Country": "CL", "Country Name": "Chile" },
  { "Country": "CN", "Country Name": "China" },
  { "Country": "CX", "Country Name": "Christmas Island" },
  { "Country": "CC", "Country Name": "Cocos (Keeling) Islands" },
  { "Country": "CO", "Country Name": "Colombia" },
  { "Country": "KM", "Country Name": "Comoros" },
  { "Country": "CG", "Country Name": "Congo" },
  { "Country": "CD", "Country Name": "Congo, Democratic Republic" },
  { "Country": "CK", "Country Name": "Cook Islands" },
  { "Country": "CR", "Country Name": "Costa Rica" },
  { "Country": "CI", "Country Name": "Cote D\"Ivoire" },
  { "Country": "HR", "Country Name": "Croatia" },
  { "Country": "CU", "Country Name": "Cuba" },
  { "Country": "CY", "Country Name": "Cyprus" },
  { "Country": "CZ", "Country Name": "Czech Republic" },
  { "Country": "DK", "Country Name": "Denmark" },
  { "Country": "DJ", "Country Name": "Djibouti" },
  { "Country": "DM", "Country Name": "Dominica" },
  { "Country": "DO", "Country Name": "Dominican Republic" },
  { "Country": "EC", "Country Name": "Ecuador" },
  { "Country": "EG", "Country Name": "Egypt" },
  { "Country": "SV", "Country Name": "El Salvador" },
  { "Country": "GQ", "Country Name": "Equatorial Guinea" },
  { "Country": "ER", "Country Name": "Eritrea" },
  { "Country": "EE", "Country Name": "Estonia" },
  { "Country": "ET", "Country Name": "Ethiopia" },
  { "Country": "FK", "Country Name": "Falkland Islands (Malvinas)" },
  { "Country": "FO", "Country Name": "Faroe Islands" },
  { "Country": "FJ", "Country Name": "Fiji" },
  { "Country": "FI", "Country Name": "Finland" },
  { "Country": "FR", "Country Name": "France" },
  { "Country": "GF", "Country Name": "French Guiana" },
  { "Country": "PF", "Country Name": "French Polynesia" },
  { "Country": "TF", "Country Name": "French Southern Territories" },
  { "Country": "GA", "Country Name": "Gabon" },
  { "Country": "GM", "Country Name": "Gambia" },
  { "Country": "GE", "Country Name": "Georgia" },
  { "Country": "DE", "Country Name": "Germany" },
  { "Country": "GH", "Country Name": "Ghana" },
  { "Country": "GI", "Country Name": "Gibraltar" },
  { "Country": "GR", "Country Name": "Greece" },
  { "Country": "GL", "Country Name": "Greenland" },
  { "Country": "GD", "Country Name": "Grenada" },
  { "Country": "GP", "Country Name": "Guadeloupe" },
  { "Country": "GU", "Country Name": "Guam" },
  { "Country": "GT", "Country Name": "Guatemala" },
  { "Country": "GG", "Country Name": "Guernsey" },
  { "Country": "GN", "Country Name": "Guinea" },
  { "Country": "GW", "Country Name": "Guinea-Bissau" },
  { "Country": "GY", "Country Name": "Guyana" },
  { "Country": "HT", "Country Name": "Haiti" },
  { "Country": "HM", "Country Name": "Heard Island & Mcdonald Islands" },
  { "Country": "VA", "Country Name": "Holy See (Vatican City State)" },
  { "Country": "HN", "Country Name": "Honduras" },
  { "Country": "HK", "Country Name": "Hong Kong" },
  { "Country": "HU", "Country Name": "Hungary" },
  { "Country": "IS", "Country Name": "Iceland" },
  { "Country": "IN", "Country Name": "India" },
  { "Country": "ID", "Country Name": "Indonesia" },
  { "Country": "IR", "Country Name": "Iran, Islamic Republic Of" },
  { "Country": "IQ", "Country Name": "Iraq" },
  { "Country": "IE", "Country Name": "Ireland" },
  { "Country": "IM", "Country Name": "Isle Of Man" },
  { "Country": "IL", "Country Name": "Israel" },
  { "Country": "IT", "Country Name": "Italy" },
  { "Country": "JM", "Country Name": "Jamaica" },
  { "Country": "JP", "Country Name": "Japan" },
  { "Country": "JE", "Country Name": "Jersey" },
  { "Country": "JO", "Country Name": "Jordan" },
  { "Country": "KZ", "Country Name": "Kazakhstan" },
  { "Country": "KE", "Country Name": "Kenya" },
  { "Country": "KI", "Country Name": "Kiribati" },
  { "Country": "KP", "Country Name": "North Korea" },
  { "Country": "KR", "Country Name": "South Korea" },
  { "Country": "KW", "Country Name": "Kuwait" },
  { "Country": "KG", "Country Name": "Kyrgyzstan" },
  { "Country": "LA", "Country Name": "Lao Peoples Democratic Republic" },
  { "Country": "LV", "Country Name": "Latvia" },
  { "Country": "LB", "Country Name": "Lebanon" },
  { "Country": "LS", "Country Name": "Lesotho" },
  { "Country": "LR", "Country Name": "Liberia" },
  { "Country": "LY", "Country Name": "Libyan Arab Jamahiriya" },
  { "Country": "LI", "Country Name": "Liechtenstein" },
  { "Country": "LT", "Country Name": "Lithuania" },
  { "Country": "LU", "Country Name": "Luxembourg" },
  { "Country": "MO", "Country Name": "Macao" },
  { "Country": "MK", "Country Name": "Macedonia" },
  { "Country": "MG", "Country Name": "Madagascar" },
  { "Country": "MW", "Country Name": "Malawi" },
  { "Country": "MY", "Country Name": "Malaysia" },
  { "Country": "MV", "Country Name": "Maldives" },
  { "Country": "ML", "Country Name": "Mali" },
  { "Country": "MT", "Country Name": "Malta" },
  { "Country": "MH", "Country Name": "Marshall Islands" },
  { "Country": "MQ", "Country Name": "Martinique" },
  { "Country": "MR", "Country Name": "Mauritania" },
  { "Country": "MU", "Country Name": "Mauritius" },
  { "Country": "YT", "Country Name": "Mayotte" },
  { "Country": "MX", "Country Name": "Mexico" },
  { "Country": "FM", "Country Name": "Micronesia, Federated States Of" },
  { "Country": "MD", "Country Name": "Moldova" },
  { "Country": "MC", "Country Name": "Monaco" },
  { "Country": "MN", "Country Name": "Mongolia" },
  { "Country": "ME", "Country Name": "Montenegro" },
  { "Country": "MS", "Country Name": "Montserrat" },
  { "Country": "MA", "Country Name": "Morocco" },
  { "Country": "MZ", "Country Name": "Mozambique" },
  { "Country": "MM", "Country Name": "Myanmar" },
  { "Country": "NA", "Country Name": "Namibia" },
  { "Country": "NR", "Country Name": "Nauru" },
  { "Country": "NP", "Country Name": "Nepal" },
  { "Country": "NL", "Country Name": "Netherlands" },
  { "Country": "AN", "Country Name": "Netherlands Antilles" },
  { "Country": "NC", "Country Name": "New Caledonia" },
  { "Country": "NZ", "Country Name": "New Zealand" },
  { "Country": "NI", "Country Name": "Nicaragua" },
  { "Country": "NE", "Country Name": "Niger" },
  { "Country": "NG", "Country Name": "Nigeria" },
  { "Country": "NU", "Country Name": "Niue" },
  { "Country": "NF", "Country Name": "Norfolk Island" },
  { "Country": "MP", "Country Name": "Northern Mariana Islands" },
  { "Country": "NO", "Country Name": "Norway" },
  { "Country": "OM", "Country Name": "Oman" },
  { "Country": "PK", "Country Name": "Pakistan" },
  { "Country": "PW", "Country Name": "Palau" },
  { "Country": "PS", "Country Name": "Palestinian Territory, Occupied" },
  { "Country": "PA", "Country Name": "Panama" },
  { "Country": "PG", "Country Name": "Papua New Guinea" },
  { "Country": "PY", "Country Name": "Paraguay" },
  { "Country": "PE", "Country Name": "Peru" },
  { "Country": "PH", "Country Name": "Philippines" },
  { "Country": "PN", "Country Name": "Pitcairn" },
  { "Country": "PL", "Country Name": "Poland" },
  { "Country": "PT", "Country Name": "Portugal" },
  { "Country": "PR", "Country Name": "Puerto Rico" },
  { "Country": "QA", "Country Name": "Qatar" },
  { "Country": "RE", "Country Name": "Reunion" },
  { "Country": "RO", "Country Name": "Romania" },
  { "Country": "RU", "Country Name": "Russian Federation" },
  { "Country": "RW", "Country Name": "Rwanda" },
  { "Country": "SH", "Country Name": "Saint Helena" },
  { "Country": "KN", "Country Name": "Saint Kitts And Nevis" },
  { "Country": "LC", "Country Name": "Saint Lucia" },
  { "Country": "PM", "Country Name": "Saint Pierre And Miquelon" },
  { "Country": "VC", "Country Name": "Saint Vincent And Grenadines" },
  { "Country": "WS", "Country Name": "Samoa" },
  { "Country": "SM", "Country Name": "San Marino" },
  { "Country": "ST", "Country Name": "Sao Tome And Principe" },
  { "Country": "SA", "Country Name": "Saudi Arabia" },
  { "Country": "SN", "Country Name": "Senegal" },
  { "Country": "RS", "Country Name": "Serbia" },
  { "Country": "SC", "Country Name": "Seychelles" },
  { "Country": "SL", "Country Name": "Sierra Leone" },
  { "Country": "SG", "Country Name": "Singapore" },
  { "Country": "SK", "Country Name": "Slovakia" },
  { "Country": "SI", "Country Name": "Slovenia" },
  { "Country": "SB", "Country Name": "Solomon Islands" },
  { "Country": "SO", "Country Name": "Somalia" },
  { "Country": "ZA", "Country Name": "South Africa" },
  { "Country": "GS", "Country Name": "South Georgia And Sandwich Isl." },
  { "Country": "ES", "Country Name": "Spain" },
  { "Country": "LK", "Country Name": "Sri Lanka" },
  { "Country": "SD", "Country Name": "Sudan" },
  { "Country": "SR", "Country Name": "Suriname" },
  { "Country": "SJ", "Country Name": "Svalbard And Jan Mayen" },
  { "Country": "SZ", "Country Name": "Swaziland" },
  { "Country": "SE", "Country Name": "Sweden" },
  { "Country": "CH", "Country Name": "Switzerland" },
  { "Country": "SY", "Country Name": "Syrian Arab Republic" },
  { "Country": "TW", "Country Name": "Taiwan" },
  { "Country": "TJ", "Country Name": "Tajikistan" },
  { "Country": "TZ", "Country Name": "Tanzania" },
  { "Country": "TH", "Country Name": "Thailand" },
  { "Country": "TG", "Country Name": "Togo" },
  { "Country": "TK", "Country Name": "Tokelau" },
  { "Country": "TO", "Country Name": "Tonga" },
  { "Country": "TT", "Country Name": "Trinidad And Tobago" },
  { "Country": "TN", "Country Name": "Tunisia" },
  { "Country": "TR", "Country Name": "Turkey" },
  { "Country": "TM", "Country Name": "Turkmenistan" },
  { "Country": "TC", "Country Name": "Turks And Caicos Islands" },
  { "Country": "TV", "Country Name": "Tuvalu" },
  { "Country": "UG", "Country Name": "Uganda" },
  { "Country": "UA", "Country Name": "Ukraine" },
  { "Country": "AE", "Country Name": "United Arab Emirates" },
  { "Country": "GB", "Country Name": "United Kingdom" },
  { "Country": "US", "Country Name": "United States" },
  { "Country": "UM", "Country Name": "United States Outlying Islands" },
  { "Country": "UY", "Country Name": "Uruguay" },
  { "Country": "UZ", "Country Name": "Uzbekistan" },
  { "Country": "VU", "Country Name": "Vanuatu" },
  { "Country": "VE", "Country Name": "Venezuela" },
  { "Country": "VN", "Country Name": "Vietnam" },
  { "Country": "VG", "Country Name": "Virgin Islands, British" },
  { "Country": "VI", "Country Name": "Virgin Islands, U.S." },
  { "Country": "WF", "Country Name": "Wallis And Futuna" },
  { "Country": "EH", "Country Name": "Western Sahara" },
  { "Country": "YE", "Country Name": "Yemen" },
  { "Country": "ZM", "Country Name": "Zambia" },
  { "Country": "ZW", "Country Name": "Zimbabwe" }
]